import { usePrincipalKey } from "@auth/sessionStore";
import { EmailAssistantPreferences } from "@email/EmailAssistantPreferences";
import { EmailPanel } from "@email/EmailPanel";

export const EmailAdminSettings = () => {
  const principalKey = usePrincipalKey();
  return (
    <div className="flex flex-col gap-6">
      <EmailPanel />
      <EmailAssistantPreferences key={principalKey} />
    </div>
  );
};
